class Accordion {
    constructor(heading) {
        this.heading = heading
    }

    showOne() {
        const accordionHeading = document.querySelectorAll(this.heading)
        const trigger = document.querySelectorAll('[data-open]')
        const closeTrigger = document.querySelectorAll('[data-collapse]')
        const primaryAcc = document.querySelector('.default')

        trigger.forEach((item, key) => {
            item.addEventListener('click', () => {
                accordionHeading.forEach(element => {
                    element.classList.contains('--is-open')
                        ? element.classList.remove('--is-open')
                        : null
                    document.querySelectorAll('.video__player video').forEach(vid => vid.pause())
                })

                item.parentElement.classList.add('--is-open')
            })
        })

        closeTrigger.forEach((item, key) => {
            item.addEventListener('click', () => {
                accordionHeading.forEach(element => {
                    element.classList.contains('--is-open')
                        ? element.classList.remove('--is-open')
                        : null
                    document.querySelectorAll('.video__player video').forEach(vid => vid.pause())
                })

                primaryAcc.classList.add('--is-open')
            })
        })
    }
}

const accordion = new Accordion('section')
accordion.showOne()
